(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["franztels-gadgets"] && !Shopify.designMode) return;
  try {
    
  function initFranztelsGadgets(root) {
    if (root.dataset.hotspotsReady) return;
    root.dataset.hotspotsReady = 'true';
    const controls = root.querySelector('.franztels-gadgets__mobile-controls');
    const panel = controls.querySelector('.franztels-gadgets__choice');
    const shop = panel.querySelector('a');
    const hotspots = controls.querySelectorAll('.franztels-gadgets__hotspot');
    const radio = root.querySelector('.franztels-gadgets__radio-link svg');
    if (radio) {
      const copy = radio.cloneNode(true);
      copy.querySelectorAll('[id]').forEach(el => { const old = el.id; el.id = old + '-mobile-' + panel.id; copy.querySelectorAll('[fill]').forEach(item => { if (item.getAttribute('fill') === 'url(#' + old + ')') item.setAttribute('fill', 'url(#' + el.id + ')'); }); });
      controls.querySelector('.franztels-gadgets__mobile-radio').replaceWith(copy);
    }
    function closePanel() {
      panel.hidden = true;
      hotspots.forEach(h => h.setAttribute('aria-expanded', 'false'));
    }
    hotspots.forEach(h => h.addEventListener('click', event => {
      event.stopPropagation();
      hotspots.forEach(item => item.setAttribute('aria-expanded', String(item === h)));
      shop.textContent = 'Shop ' + h.dataset.label + ' →';
      shop.href = h.dataset.url;
      panel.hidden = false;
    }));
    controls.querySelector('.franztels-gadgets__dismiss').addEventListener('click', closePanel);
    root.addEventListener('click', event => { if (!event.target.closest('.franztels-gadgets__hotspot, .franztels-gadgets__choice')) closePanel(); });
    root.addEventListener('keydown', event => { if (event.key === 'Escape') closePanel(); });
    shop.addEventListener('click', () => sessionStorage.setItem('franztels-gadgets-return', location.pathname));
  }
  document.querySelectorAll('.franztels-gadgets').forEach(initFranztelsGadgets);
  document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('.franztels-gadgets').forEach(initFranztelsGadgets));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  const routeTemporaryHeaderLinks = () => {
    document.querySelectorAll('.section-header a, .menu-drawer a, .footer a').forEach((link) => {
      const path = new URL(link.href, window.location.origin).pathname.replace(/\/$/, '');
      const isHomeLink = path === '';
      const isPetParlorLink = path === '/pages/under-construction' && new URL(link.href, window.location.origin).searchParams.get('view') === 'pet-parlor';
      const isFranztelsBackLink = link.classList.contains('header__icon--franztels-back');
      const livePaths = [
        '/pages/automotive',
        '/pages/interior',
        '/pages/gadgets',
        '/collections/interior-organization',
        '/collections/grooming-care',
        '/products/microfiber-pet-drying-towel-with-hand-pockets',
        '/products/pu-leather-car-seat-back-organizer-fold-down-tray',
        '/products/ap-1-obd-gps-smart-car-hud-display',
        '/products/magnetic-car-phone-holder-with-suction-mount'
      ];
      const isLiveFranztelsLink = livePaths.includes(path);

      if (!isHomeLink && !isPetParlorLink && !isFranztelsBackLink && !isLiveFranztelsLink) {
        link.href = '/pages/under-construction';
      }
    });

    const cartLink = document.querySelector('#cart-icon-bubble');

    if (cartLink) {
      cartLink.addEventListener(
        'click',
        (event) => {
          event.preventDefault();
          event.stopImmediatePropagation();
          window.location.href = '/pages/under-construction';
        },
        true
      );
    }
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', routeTemporaryHeaderLinks);
  } else {
    routeTemporaryHeaderLinks();
  }


  } catch(e) { console.error(e); }
})();
})();
